import { useTranslation } from 'react-i18next';

import { Icon } from 'components/Icon';

import * as S from './Warning.styles';

type WarningProps = {
  children: React.ReactNode;
};

export function Warning(props: WarningProps): React.ReactElement {
  const { children } = props;
  const { t } = useTranslation();
  return (
    <S.Container>
      <Icon name="FiAlertTriangle" />

      <S.Text fontFamily="LFT Zeno" scale="s" color="warningText">
        {t('common.warning')} {children}
      </S.Text>
    </S.Container>
  );
}
